import styled from "@emotion/styled";

export const SliderWrapper = styled.section<{backgroundColor?: string}>(
  ({theme, backgroundColor}) => {
    const color =
      backgroundColor === "white"
        ? theme?.colors?.primaryWhite
        : theme?.colors?.backgroundGrey;
    return {
      backgroundColor: color,
      paddingTop: theme?.breakpoints?.isMobile ? 20 : 30,
      paddingBottom: theme?.breakpoints?.isMobile ? 20 : 30,
      ".swiper-scrollbar": {
        left: "50%",
        transform: "translateX(-50%)",
        width: theme?.breakpoints?.isMobile ? "100%" : "75%",
        height: theme?.breakpoints?.isMobile ? 3 : 6,
        borderTopWidth: theme?.breakpoints?.isMobile ? 1 : 2,
        borderTopStyle: "solid",
        borderTopColor: color,
        backgroundColor: theme?.colors?.primaryGrey,
        WebkitClipPath: theme?.breakpoints?.isMobile
          ? "polygon(1% 100%, 1.2% 0%, 99% 0%, 98.8% 100%)"
          : "polygon(1% 100%, 1.6% 0%, 99% 0%, 98.6% 100%)",
        clipPath: theme?.breakpoints?.isMobile
          ? "polygon(1% 100%, 1.2% 0%, 99% 0%, 98.8% 100%)"
          : "polygon(1% 100%, 1.6% 0%, 99% 0%, 98.6% 100%)",
      },
      ".swiper-scrollbar-drag": {
        bottom: 0,
        top: -2,
        width: "auto",
        height: 8,
        backgroundColor: theme?.colors?.brandBlue,
        WebkitClipPath: "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)",
        clipPath: theme?.breakpoints?.isMobile
          ? "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)"
          : "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)",
        cursor: "pointer",
        borderRadius: 0,
        transitionDuration: theme?.breakpoints?.isMobile
          ? "0.4s !important"
          : "0.1s !important",
        transitionTimingFunction: theme?.breakpoints?.isMobile ? "ease-in-out" : "ease",
      },
      ".swiper-slide": {
        width: "auto",
        height: "100%",
      },
    };
  },
);

export const ImgWrapper = styled.img<{
  aspectRatioHeight?: number;
  aspectRatioWidth?: number;
}>(({aspectRatioHeight = 9, aspectRatioWidth = 16, theme}) => ({
  display: "block",
  width: "auto",
  height: theme?.breakpoints?.isMobile ? 200 : 457,
  aspectRatio: `${aspectRatioWidth} / ${aspectRatioHeight}`,
  objectFit: "cover",
  borderRadius: theme?.breakpoints?.isMobile ? 16 : 24,
}));

export const SlideContentWrapper = styled.div({
  display: "block",
  width: "100%",
});
